/**
 * Initializes the dynamic elements by listening to the click event on the container element
 */

async function initializeDynamicElements() {
  const processingMap = new Map();

  const { getJSON, getData, createEl } = await import('../../../tools/basic-functions.js');

  const deviceType = _CMS_MOBILE ? 'mobile' : 'desktop';
  const dynamicElementsData = await getJSON(`json/dynamic-elements.json?device=${deviceType}`);
  if (!dynamicElementsData) return;

  const { containerSelector, elements } = dynamicElementsData;
  const containerElement = document.querySelector(containerSelector);

  const initDynamicElement = async (key, data) => {
    if (processingMap.get(key)) return;

    const {
      jsonPath,
      parentSelector,
      removeHash,
      removeActiveSelector,
      elementSelector,
      toggleSelector,
      toggleActiveSelector
    } = data;
    const element = document.querySelector(elementSelector);

    if (removeActiveSelector) {
      const removeActiveElements = document.querySelectorAll(removeActiveSelector);

      for (const removeActiveElement of removeActiveElements) {
        if (element?.isSameNode(removeActiveElement)) continue;
        removeActiveElement.classList.toggle('active', false);
      }
    }

    if (element?.classList.contains('active')) {
      element.classList.toggle('active', false);
      //window.dispatchEvent(new Event("resize"));
      window.dispatchEvent(new Event('GAME_SIDEBAR_UPDATE'));
      return;
    }

    /**
    * DEPRECATED
    *
    if (removeSelector) {
      const removeElements = document.querySelectorAll(removeSelector);
      for (const removeElement of removeElements) {
        if (element?.isSameNode(removeElement)) continue;
        removeElement.remove();
      }
    }
  */

    if (removeHash === window.location.hash) {
      window.location.hash = '';
    }

    let dynamicElement;
    let hasError = false;
    if (!element && parentSelector) {
      processingMap.set(key, true);

      try {
        const parentElement = document.querySelector(parentSelector);
        if (!parentElement) throw new Error('No parent element found.');

        if (jsonPath) {
          const { response: data } = await getData(
            `${_CMS_LOCALE != '' ? _CMS_LOCALE : _CMS_LANGUAGE}/json/${jsonPath}?device=${deviceType}`
          );

          dynamicElement = createEl(data);
          parentElement.appendChild(dynamicElement);
        }
      } catch (error) {
        console.error('Error processing dynamic element:', error);
        hasError = true;
      } finally {
        processingMap.set(key, false);
      }
    }
    if (!hasError) {
      (dynamicElement || element)?.classList.toggle('active', true);
    }
    window.dispatchEvent(new Event('GAME_SIDEBAR_UPDATE'));

    const { dynamicElementsService } = await import('./dynamic-elements-service');
    dynamicElementsService(dynamicElement || element, key);

    toggleToggleElement(toggleSelector, true, toggleActiveSelector);
    return;
  };

  for (const [key, data] of Object.entries(elements)) {
    if (data.autoInit) {
      initDynamicElement(key, data);
    }
  }

  containerElement?.addEventListener('click', async (event) => {
    for (const [key, data] of Object.entries(elements)) {
      const { toggleSelector } = data;
      if (!event.target.closest(toggleSelector)) continue;
      console.log('click', key, data);
      initDynamicElement(key, data);
    }
  });

  window.addEventListener('GAME_SIDEBAR_UPDATE', () => {
    for (const key of Array.from(processingMap.keys())) {
      const { toggleActiveSelector, toggleSelector, elementSelector } = elements[key];
      if (!toggleActiveSelector || !toggleSelector || !elementSelector) continue;

      const element = document.querySelector(elementSelector);
      if (!element) continue;

      toggleToggleElement(toggleSelector, false, toggleActiveSelector);
    }
  });
}

async function loadDynamicElement(jsonPath) {
  if (!jsonPath) return null;
  const deviceType = _CMS_MOBILE ? 'mobile' : 'desktop';
  const { getData, createEl } = await import('../../../tools/basic-functions.js');

  const { response: data } = await getData(
    `${_CMS_LOCALE != '' ? _CMS_LOCALE : _CMS_LANGUAGE}/json/${jsonPath}?device=${deviceType}`
  );

  return createEl(data);
}

function toggleToggleElement(toggleSelector, isActive = false, toggleActiveSelector = false) {
  if (toggleActiveSelector && toggleSelector) {
    const toggleElements = document.querySelectorAll(toggleSelector);
    for (const toggleElement of toggleElements) {
      toggleElement.classList.toggle('active', isActive);
    }
  }
}

export { initializeDynamicElements, loadDynamicElement };
